import * as consts from './ModalsConsts';

export const changeModalVisibility = (name, value = undefined) => {
    return (dispatch, getState) => {
        const newName = name + 'IsOpen';
        if (value === undefined) {
            dispatch({
                type: consts.CHANGE_MODAL_VISIBILITY,
                payload: {
                    name: newName,
                    value: !getState().modals[newName]
                }
            });
        } else {
            dispatch({
                type: consts.CHANGE_MODAL_VISIBILITY,
                payload: {
                    name: newName,
                    value
                }
            })
        }
    }
}